import React from 'react';
import Area from '@splunk/dashboard-visualizations/Area';

export default () => (
    <Area
        options={{
            'axisY.includeZero': true,
            'axisLabelsY.majorUnit': 500,
            'axisY.minimumNumber': 500,
        }}
        encoding={{
            x: 'primary.component',
            y: 'primary.count',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'component', groupby_rank: '0' }, { name: 'count' }],
                    columns: [
                        ['ApplicationLicense', 'DatabaseDirectoryManager', 'IndexWriter'],
                        ['1000', '2000', '4000'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
